// config
import axios from 'axios';

const moveTicketToTMS = async ({ id, orderIdDTO }) => {
  const token = 'FgTJfl4Orng6YP3YGqBznJ5DjmgKis';
  const requestConfig = {
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: orderIdDTO,
  };

  return await axios.post(
    `http://localhost:8000/v1/price-negotiation/tickets/${id}/completions/`,
    requestConfig
  );
};

export default moveTicketToTMS;
